import {
   WINDOW_RESIZE,
   TOGGLE_SELECT_JOURNEY,
   TIMER_TICK,
   RESET_INACTIVITY_TIMER,
   TOGGLE_IDLE_WARNING
} from '../constants/util-constants'

import moment from 'moment'

export const windowResize = (windowHeight, windowWidth) => {
  return dispatch => {
    dispatch({
      type: WINDOW_RESIZE,
      payload: { windowHeight, windowWidth }
    })
  }
}

export const toggleSelectJourneyModal = (galleryId, showAdultOnly = false) => {
   return dispatch => {
      dispatch({
         type: TOGGLE_SELECT_JOURNEY,
         payload: {galleryId, showAdultOnly}
      })
   }
}

export const timerTick = () => {
  return dispatch => {
    dispatch({
      type: TIMER_TICK,
    })
  }
}

export const resetInactivityTimer = (galleryId) => {
  return dispatch => {
    //dispatch(toggleIdleWarning(galleryId, false))
    dispatch({
      type: RESET_INACTIVITY_TIMER,
      payload: { galleryId }
    })
  }
}

export const toggleIdleWarning = (galleryId, toggleState) => {
  return dispatch => {
    dispatch({
      type: TOGGLE_IDLE_WARNING,
      payload: { galleryId, toggleState }
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/util-actions.js